'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

export function useAuthValidation() {
  const [isLoading, setIsLoading] = useState(true);
  const router = useRouter();

  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await fetch('/api/validateToken', { method: 'POST' });

        if (!response.ok) {
          throw new Error('Unauthorized');
        }

        setIsLoading(false); // Token is valid, allow access
      } catch (error) {
        setIsLoading(false);
        router.replace('/login'); // Redirect to login if token is invalid
      }
    };

    validateToken();
  }, [router]);

  return { isLoading };
}
